export const FILE_TYPE = {
    1: "Audio",
    2: "Video",
    3: "Image",
    4: "Document",
    5: "Weblink",
}